import React from 'react';
import propTypes from 'prop-types';

import useTheme from 'Hooks/useTheme';
import 'Features/Product/components/Reviews/ReviewScoreLogo.scss';

export default function ReviewScoreLogo({ reviewCount, logo, score }) {
  const siteTheme = useTheme();

  const names = {
    metaCritic: 'MetaCritic',
    openCritic: 'OpenCritic',
  };

  let title = {
    metaCritic: 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-text-white.svg',
    openCritic: 'https://cdn.fanatical.com/production/brand/opencritic/svg/opencritic-text-white.svg',
  };

  if (siteTheme === 'light') {
    title = {
      metaCritic: 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-text-black.svg',
      openCritic: 'https://cdn.fanatical.com/production/brand/opencritic/svg/opencritic-text-black.svg',
    };
  }

  const logos = {
    metaCritic: 'https://cdn.fanatical.com/production/brand/metacritic/svg/metacritic-icon.svg',
    openCritic: 'https://cdn.fanatical.com/production/brand/opencritic/svg/opencritic-icon.svg',
  };

  return (
    <div className="ReviewScore">
      <div className="ReviewScore__score">
        {score}
      </div>
      <div className="ReviewScore__logo">
        <div className="ReviewScore__logo__icon">
          <img
            src={logos[logo]}
            alt={names[logo]}
          />
        </div>
        <div className="ReviewScore__logo__main">
          <div className="ReviewScore__logo__main__image">
            <img
              src={title[logo]}
              alt={names[logo]}
            />
          </div>
          <div className="ReviewScore__logo__main__count">
            Based on {reviewCount} Critics
          </div>
        </div>
      </div>
    </div>
  );
}

ReviewScoreLogo.propTypes = {
  reviewCount: propTypes.number,
  logo: propTypes.string,
  score: propTypes.number,
};

ReviewScoreLogo.defaultProps = {
  reviewCount: 0,
  logo: 'metaCritic',
  score: 0,
};
